import { render, staticRenderFns } from "./ButtonRadios.vue?vue&type=template&id=c1dbff1c"
import script from "./ButtonRadios.vue?vue&type=script&lang=js"
export * from "./ButtonRadios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports